import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
const termsContent = {
  title: 'Conditions Générales de Vente',
  sections: [{
    heading: '1. Objet',
    text: "Les présentes conditions générales de vente régissent l'achat du pack numérique « Récolte Urbaine : Le Système Anti-Épicerie » (ci-après « le Produit »). En passant commande, l'acheteur accepte sans réserve les présentes conditions."
  }, {
    heading: '2. Produit',
    text: "Le Produit est un ensemble de contenus numériques (ebook PDF, calendrier de semis, guide d'économies) livrés par téléchargement immédiat après paiement. Aucun produit physique n'est expédié."
  }, {
    heading: '3. Prix et Paiement',
    text: 'Le prix du Produit est indiqué en dollars canadiens (CAD), toutes taxes comprises. Le paiement est effectué en ligne par carte bancaire via une plateforme de paiement sécurisée. La transaction est chiffrée et vos données bancaires ne sont jamais stockées sur nos serveurs.'
  }, {
    heading: '4. Livraison',
    text: "L'accès au Produit est fourni immédiatement après confirmation du paiement, par lien de téléchargement envoyé à l'adresse e-mail indiquée lors de la commande."
  }, {
    heading: '5. Garantie de Satisfaction',
    text: "Vous bénéficiez d'une garantie satisfait ou remboursé de 30 jours à compter de la date d'achat. Si le Produit ne répond pas à vos attentes, vous pouvez demander un remboursement intégral sans justification."
  }, {
    heading: '6. Propriété Intellectuelle',
    text: "Le contenu du Produit est protégé par le droit d'auteur. L'acheteur bénéficie d'une licence d'utilisation personnelle et non transférable. Toute reproduction, redistribution ou revente est strictement interdite."
  }, {
    heading: '7. Limitation de Responsabilité',
    text: 'Les résultats obtenus dépendent de nombreux facteurs (climat, entretien, conditions locales). Récolte Urbaine ne garantit pas de résultats spécifiques et ne saurait être tenu responsable des résultats individuels.'
  }]
};
const privacyContent = {
  title: 'Politique de Confidentialité',
  sections: [{
    heading: '1. Collecte des Données',
    text: "Nous collectons uniquement les informations nécessaires au traitement de votre commande : adresse e-mail et informations de paiement. Aucune donnée personnelle supplémentaire n'est requise."
  }, {
    heading: '2. Utilisation des Données',
    text: "Vos données sont utilisées exclusivement pour : le traitement et la livraison de votre commande, l'envoi de votre lien de téléchargement, et la communication relative à votre achat (confirmation, suivi)."
  }, {
    heading: '3. Protection des Données',
    text: 'Nous mettons en œuvre des mesures de sécurité techniques et organisationnelles pour protéger vos données personnelles contre tout accès non autorisé, modification, divulgation ou destruction.'
  }, {
    heading: '4. Partage des Données',
    text: 'Vos données personnelles ne sont jamais vendues, échangées ou louées à des tiers. Elles peuvent être partagées uniquement avec notre prestataire de paiement dans le cadre strict du traitement de votre transaction.'
  }, {
    heading: '5. Cookies',
    text: "Notre site peut utiliser des cookies à des fins d'analyse et d'amélioration de l'expérience utilisateur. Vous pouvez configurer votre navigateur pour refuser les cookies, bien que cela puisse affecter certaines fonctionnalités."
  }, {
    heading: '6. Vos Droits',
    text: "Conformément à la législation applicable, vous disposez d'un droit d'accès, de rectification et de suppression de vos données personnelles. Pour exercer ces droits, veuillez nous contacter par e-mail."
  }, {
    heading: '7. Modifications',
    text: 'Nous nous réservons le droit de modifier cette politique de confidentialité à tout moment. Les modifications prennent effet dès leur publication sur cette page.'
  }]
};
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const content = activeModal === 'terms' ? termsContent : privacyContent;
  return <>
      <footer className="bg-charcoal text-cream/50 py-8 text-center font-sans text-sm" data-id="element-65">
        <div className="max-w-[1100px] mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-66">
          <p data-id="element-67">
            © {new Date().getFullYear()} Récolte Urbaine. Tous droits réservés.
          </p>
          <div className="flex gap-6" data-id="element-68">
            <button onClick={() => setActiveModal('terms')} className="hover:text-cream transition-colors cursor-pointer" data-id="element-69">
              Conditions Générales
            </button>
            <button onClick={() => setActiveModal('privacy')} className="hover:text-cream transition-colors cursor-pointer" data-id="element-70">
              Politique de Confidentialité
            </button>
          </div>
        </div>
      </footer>

      <AnimatePresence data-id="element-71">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.25
      }} className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-charcoal/70 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-72">
            <motion.div initial={{
          opacity: 0,
          y: 30,
          scale: 0.97
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} exit={{
          opacity: 0,
          y: 20,
          scale: 0.97
        }} transition={{
          duration: 0.3,
          ease: 'easeOut'
        }} className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[85vh] overflow-hidden flex flex-col" onClick={e => e.stopPropagation()} data-id="element-73">
              {/* Header */}
              <div className="flex items-center justify-between px-8 py-6 border-b border-cream-dark" data-id="element-74">
                <h2 className="font-serif text-2xl font-bold text-forest" data-id="element-75">
                  {content.title}
                </h2>
                <button onClick={() => setActiveModal(null)} className="p-2 rounded-full hover:bg-cream transition-colors text-charcoal/60 hover:text-charcoal" aria-label="Fermer" data-id="element-76">
                  <XIcon className="w-5 h-5" data-id="element-77" />
                </button>
              </div>

              {/* Body */}
              <div className="overflow-y-auto px-8 py-6 space-y-6 flex-1" data-id="element-78">
                {content.sections.map((section, index) => <div key={index} data-id="element-79">
                    <h3 className="font-sans font-bold text-charcoal text-base mb-2" data-id="element-80">
                      {section.heading}
                    </h3>
                    <p className="font-sans text-charcoal/70 text-sm leading-relaxed" data-id="element-81">
                      {section.text}
                    </p>
                  </div>)}
              </div>

              {/* Footer */}
              <div className="px-8 py-4 border-t border-cream-dark bg-cream/30" data-id="element-82">
                <button onClick={() => setActiveModal(null)} className="w-full py-3 bg-forest hover:bg-forest-light text-white font-sans font-semibold rounded-lg transition-colors" data-id="element-83">
                  Fermer
                </button>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}